export default class RequestError extends Error {
  correlationId?: string;

  displayDuration?: number;

  status: number;

  statusCode?: string;

  constructor(
    status: number,
    message: string,
    statusCode?: string,
    displayDurationString?: string | number,
    correlationId?: string,
  ) {
    super(message);
    // default to undefined for potential of falsy string
    this.displayDuration = displayDurationString ? Number(displayDurationString) : undefined;
    this.status = status;
    this.statusCode = statusCode;
    this.correlationId = correlationId || undefined;
  }
}
